// Backstage's theme resolver follows the OS `prefers-color-scheme` when the user
// has never made a selection (see core-app-api `AppThemeProvider.resolveTheme`).
// We want dark to be the Golden Hippo default regardless of OS, so on first load
// — when nothing is stored — we seed the stored selection to 'dark'. The user's
// own choice in Settings always overrides this (it writes the same key).
//
// This reads Backstage's storage key ('theme'). If a future Backstage version
// ever renamed it, this becomes a no-op and the app simply falls back to the
// OS-aware default (dark-first) — a graceful softening, never a breakage. Must
// run before the app bootstraps the theme API (call it from index.tsx).
const THEME_STORAGE_KEY = 'theme';
const DEFAULT_THEME_ID = 'dark';

export function applyDefaultThemePreference(): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    if (window.localStorage.getItem(THEME_STORAGE_KEY) === null) {
      window.localStorage.setItem(THEME_STORAGE_KEY, DEFAULT_THEME_ID);
    }
  } catch {
    // Private-mode / disabled storage — fall back to OS-aware resolution.
  }
}
